// extracted by mini-css-extract-plugin
export default {"infogram":"Infogram_infogram__3UC3-"};